<template>
<div v-show="isModalVisible">
<div class="modal-mask" @click="closeModal">
      <div class="modal-container" @click.stop>
      <!-- Modal Header -->
      <div class="modal-header">
        <h6 class="modal-title">{{ modal_title }}</h6>
        <button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
        <div class="goal-content">
          <p class="font-weight-bold">Task:</p>
          <p>{{ taskDescription }}</p>
        </div>
        <div class="goal-form">
          <div v-show="submit_form_errors" class="validate-warning-msg">{{ submit_form_errors }}</div>
          
            <div class="form-group row">
              <label class="col-12 col-sm-7 col-lg-7 col-xl-7 goal_label p-0" style="padding-left: 5px !important;">
                # of Reps <span v-if="task_rep > 0"><br/> ({{ task_rep }} recorded)</span>
                <span class="required">*</span>
              </label>
              <div class="col-12 col-sm-6 col-lg-5 col-xl-5">
                <input 
                  name="No of Reps"
                  placeholder="# of Reps"
                  type="text" 
                  v-model="rep_count"
                  v-validate="'required|numeric|min_value:1'"
                  class="mx-input"
                  min="0"
                  maxlength="4">
              </div>
              <div v-if="verrors.firstByRule('No of Reps', 'required')" :class="'validate-warning-msg ' + vmessage">No of Reps is required</div>
              <div v-if="verrors.firstByRule('No of Reps', 'numeric')" :class="'validate-warning-msg ' + vmessage">No of Reps field may only contain numeric characters</div>
              <div v-if="verrors.firstByRule('No of Reps', 'min_value')" :class="'validate-warning-msg ' + vmessage">No of Reps field must be 1 or more.</div>
            </div>
            <div class="form-group row">
              <label class="col-12 col-sm-6 col-md-6 col-lg-7 col-xl-7 goal_label p-0" style="padding-left: 5px !important;">
                # of Task Hours <span v-if="task_hours > 0"> <br/> ({{ calchoursonly(task_hours) }} recorded) </span>
                <span class="required">*</span>
              </label>
              <div class="col-12 col-sm-6 col-md-6 col-lg-5 col-xl-5">
                <input 
                  name="Task Hours"
                  placeholder="# of Task Hours"
                  type="text" 
                  v-model="hours"
                  v-validate="'required|numeric|min_value:1'"
                  class="mx-input"
                  min="0"
                  maxlength="4">
              </div>
              <div v-if="verrors.firstByRule('Task Hours', 'required')" :class="'validate-warning-msg ' + vmessage">No of Task Hours is required</div>
              <div v-if="verrors.firstByRule('Task Hours', 'numeric')" :class="'validate-warning-msg ' + vmessage">No of Task Hours field may only contain numeric characters</div>
              <div v-if="verrors.firstByRule('Task Hours', 'min_value')" :class="'validate-warning-msg ' + vmessage">No of Task Hours field must be 1 or more.</div>
            </div>
            <div class="form-group row">
              <label class="col-12 col-sm-6 col-md-6 col-lg-7 col-xl-7 goal_label p-0" style="padding-left: 5px !important;">
                Completion Date
              </label>
              <div class="col-12 col-sm-6 col-md-6 col-lg-5 col-xl-5">
                <date-picker
                  name="Completion Date"
                  v-model="completion_date"
                  format="MM/DD/YYYY"
                  :disabled-date="notBeforeToday"
                  v-bind:clearable="false"
                  v-bind:editable="false"
                  :popup-style="datePickerStyle">
                  <template v-slot:icon-calendar>
                    <i class="fa fa-calendar red-color" aria-hidden="true"></i>
                  </template>
                </date-picker>
              </div>
              <div v-show="verrors.has('Completion Date')" :class="'validate-warning-msg ' + vmessage">{{ verrors.first('Completion Date') }}</div>
            </div>
            <div v-if="showWait == false" class="text-center pad-20">
                <button type="submit" class="btn btn-sm btn-blue goal_btn text-center" v-on:click="onSubmit()">{{ submit_value }}</button>
            </div>

            <div v-if="showWait == true" class="text-center pad-20">
                <button type="submit" class="btn btn-sm btn-blue goal_btn text-center">Please wait...</button>
            </div>


          
        </div>
      </div>
     </div>
</div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import router from '../../router/index.js';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

const today = new Date();
today.setHours(0, 0, 0, 0);

export default {
  props: [
    'isModalVisible',
    'modal_title',
    'submit_value',
    'menteeId',
    'tasklistId',
    'subTaskId',
    'headingId',
    'searchText',
    'originFrom'
    ],
  data() {
    return {
      datePickerStyle: {},
      submit_form_errors: '',
      goal_id: '',
      completion_date: '',
      hours: '',
      rep_count: '',
      task_hours: '',
      task_rep: '',
      taskId: '',
      taskDescription: '',
      score: '',
      formType: '',
      vmessage: '',
      showWait: false,
    }
  },
  components: {
    DatePicker
  },
  methods: {
    notBeforeToday(date) {
      return date < today;
    },
    navigate() {
      var navigatePath = this.$router.currentRoute.path;
      if (this.subTaskId) {
        navigatePath += '?e1=' + this.subTaskId;
      }
      if (this.headingId) {
        navigatePath += '&e2=' + this.headingId;
      }
      if (this.searchText) {
        navigatePath += '&e6=' + this.searchText;
      }
      if (this.tasklistId) {
        if (!this.subTaskId && !this.headingId) {
          navigatePath += '?e4=' + this.tasklistId;
        } else {
          navigatePath += '&e4=' + this.tasklistId;
        }
      }

      if (this.originFrom) {
        navigatePath += '&e7=' + this.originFrom;
      }
      this.$router.push(navigatePath)
      this.$router.go();
    },
    closeModal() {
      this.$validator.errors.clear();
      this.$emit('close');
    },
    formatDate(date) {
      const today = new Date(date);
      today.setHours(0, 0, 0, 0);
      return today;
    },
        calchoursonly: function(minutes) {
            var hours = (minutes / 60);
            var rhours = Math.floor(hours);
            var min = (hours - rhours) * 60;
            var rminutes = Math.round(min);
            if(rminutes > 0) {
                return rhours + " hr. " + rminutes + " min ";
            }
            else {
                return rhours + " hr. ";
            }
        },

    getTaskItem(item, msg) {
      //console.log(item)
      this.taskId = item.id ? item.id : '';
      this.taskDescription = item.description ? item.description : '';
      this.score = item.score ? item.score : '';
      this.vmessage = msg;
      if (Object.keys(item.goal).length > 0) {
        this.formType="edit";
        if(item.goal.completion_date != '01/01/1970') {
          this.completion_date = item.goal.completion_date ? this.formatDate(item.goal.completion_date) : '';
        }
        
        this.hours = item.goal.goal_hours ? item.goal.goal_hours : '';
        this.rep_count = item.goal.goal_rep ? item.goal.goal_rep : '';
        this.task_hours = item.goal.task_hours ? item.goal.task_hours : '';
        this.task_rep = item.goal.task_rep ? item.goal.task_rep : '';
        this.goal_id = item.goal.id ? item.goal.id : '';
      } else {
        this.formType="add";
        this.completion_date = '';
        this.hours = '';
        this.rep_count = '';
        this.task_hours = '';
        this.task_rep = '';
      }
      this.datePickerStyle['left'] = '50%';
      this.datePickerStyle['top'] = '50%';
      this.datePickerStyle['transform'] = 'translate(-30%, -60%)';
      this.datePickerStyle['z-index'] = '9999';
      this.$validator.errors.clear();
    },
    onSubmit () {
      this.vmessage = "show_vmessage";
      this.$validator.validateAll().then((result) => {
          if(!result) {
            return;
          }
          this.saveGoal();
      }).catch(() => {
          // catches the error;
      });
    },
    saveGoal() {
      this.showWait = true;
      if (this.formType == "edit") {
        axios('/mobile/update-goal',
        {
          method: 'PATCH',
          data: {
            goal_id: this.goal_id,
            rep_count: this.rep_count,
            hours: this.hours,
            completion_date: moment(new Date(this.completion_date)).format('YYYY/MM/DD'),
          },
        })
        .then(() => {
          this.flash({ message: 'Goal updated successfully', variant: 'success' });
          this.closeModal();
          this.navigate();
          this.showWait = false;
        })
        .catch((error) => {
          // console.log(error)
          this.showWait = false;
          this.submit_form_errors = error.response.data.message;
        });
      } else {
        axios('/desktop/create-goal',
        {
          method: 'POST',
          data: {
            tasklist_id: this.tasklistId,
            mentee_id: this.menteeId,
            task_id: this.taskId,
            rep_count: this.rep_count,
            hours: this.hours,
            completion_date: moment(new Date(this.completion_date)).format('YYYY/MM/DD'),
            account_id: this.$store.state.user_accountid,
          },
        })
        .then(() => {
          this.flash({ message: 'Goal created successfully', variant: 'success' });
          this.closeModal();
          this.navigate();
          this.showWait = false;
        })
        .catch((error) => {
          this.showWait = false;
          // console.log(error)
          this.submit_form_errors = error.response.data.message;
        });
      }
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
}
.modal-container {
  position: fixed;
  left: 50%;
  top: 50%;
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 500px;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;  
}
.modal-body {
  margin: 0px;
  padding: 10px;
}
.modal-header .sub-heading {
  background-color: #FFF;
  color: #555;
}
.modal-header {
  padding: 5px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.history-table-wrapper {
  height: 350px;
  overflow-y: auto;
}
.modal-footer {
  border-top: none;
}
.btn-danger {
  background-color: #00ACEE;
  border-color: #00ACEE;
}
.modal-title {
  font-size: 14px;
  font-weight: 900;
}
.goal-content { 
  padding: 0;
  margin: 0;
}
.goal-content p { margin-bottom: 0rem; }
.goal-form {
  margin: 20px 0;
  font-size: 13px;
}
.modal-header {
  border-bottom: 0px;
  margin-bottom: 10px;
}
.modal-body {
  padding: 5px;
}
.goal_label {
  font-weight: 900;
  line-height: 10px;
}
.goal_label span {
  font-weight: normal;
}
.goal_btn {
  color: #FFF; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-weight: 900;
  width: 120px;
}
.mx-input { height: 24px; }
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
.mx-datepicker { width: 100%; }
/* Small Devices */
@media (min-width: 320px) and (max-width: 991px) { 
  .modal-container {
    width: 100%;
  }
}
@media (min-width: 1280px) { 
  .form-group {
    margin: 20px;
  }
}
.form-group {
  margin: 10px 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/manager/add_goal.vue